import "twin.macro";

import { useDispatch } from "react-redux";

import { FilterNoneOutlined } from "@mui/icons-material";
import { Tooltip } from "@mui/material";

import { variantName } from "@features/items";
import { DemandPlanVariant } from "@models/DemandPlanVariant";
import { setItemPreview } from "@redux/slices/items/itemSlice";

import {
  OrderWindowTooltipTitle,
  WideTooltip,
} from "./DemandPlanVariantTooltips";

export const DemandPlanVariantItemColumn = ({
  demandPlanVariant: dpv,
}: {
  demandPlanVariant: DemandPlanVariant;
}) => {
  const dispatch = useDispatch();
  const productLabel = `${dpv.variant.externalWarehouseId} / ${dpv.variant.item.name} ${variantName(dpv.variant)}`;
  return (
    <div tw="flex-1 flex flex-col py-2.5">
      <span
        tw="hover:cursor-pointer hover:underline max-w-[250px] truncate"
        onClick={() => dispatch(setItemPreview({ id: dpv.variant.item.id }))}
      >
        <Tooltip title={productLabel}>
          <span>{productLabel}</span>
        </Tooltip>
      </span>
      <span tw="text-xs">
        Supplier: {dpv.supplierName}
        <WideTooltip
          enterDelay={500}
          enterNextDelay={500}
          title={<OrderWindowTooltipTitle demandPlanVariant={dpv} />}
        >
          <FilterNoneOutlined tw="cursor-default text-lg pl-1 relative -top-0.5" />
        </WideTooltip>
      </span>
    </div>
  );
};
